// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { emptyGuid } from "@insite/client-framework/Common/StringHelpers";
import { Category } from "@insite/client-framework/Services/CategoryService";
import { getSelectedCategoryPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { ActiveState, SeoAppProps } from "@awc/App/Widgets/SearchEngineOptimization/Type";

const getCollectionPageActiveState = ({ state, currentPage, payload }: SeoAppProps): ActiveState => {
    const location = getLocation(state);

    const allowedPages =
        currentPage.type === "CategoryDetailsPage" ||
        currentPage.type === "ProductListPage" ||
        location.pathname === payload.allProductsPageUrl;

    if (!allowedPages) {
        return false;
    }

    if (location.pathname !== payload.allProductsPageUrl) {
        const location = getLocation(state);

        const categoryPath =
            getSelectedCategoryPath(state) ||
            (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);

        const catalogPageState = getCatalogPageStateByPath(state, categoryPath);

        payload.category = getCategoryState(
            state,
            catalogPageState.value?.categoryIdWithBrandId ?? catalogPageState.value?.categoryId,
        )?.value;

        return !!payload?.category?.subCategoryIds?.length;
    }

    const allCategories: Category[] = [];
    const categoriesDataView = state.data.categories.parentCategoryIdToChildrenIds;

    if (categoriesDataView[emptyGuid]) {
        categoriesDataView[emptyGuid].forEach(categoryId => {
            const category = getCategoryState(state, categoryId).value;
            if (category) {
                allCategories.push(category);
            }
        });
    }

    payload.categories = allCategories;
    return !!allCategories?.length;
};

export default getCollectionPageActiveState;
